<template>
  <div class="p-5 flex flex-col">
    <div class="flex flex-row items-center">
      <div
        class="min-w-8 self-center cursor-pointer"
        @click="handleBack"
      >
        <img :src="require('@/assets/shipo-icon-arrow-left.svg')">
      </div>
      <p class="font-semibold text-3xl">
        {{ this.$route.meta.title }}
      </p>
    </div>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <div class="grid grid-cols-4 gap-2 w-1/2 font-semibold">
        <p>
          SERVICE TRIP NO.
        </p>
        <p>
          :  {{ dailyTripData.trip_number || '-' }}
        </p>
        <p>
          BARGE NAME
        </p>
        <p>
          :  {{ dailyTripData.barge_name || '-' }}
        </p>
        <p>
          TUG NAME
        </p>
        <p>
          :  {{ dailyTripData.tug_name || '-' }}
        </p>
        <p>
          BUYER
        </p>
        <p>
          :  {{ dailyTripData.buyer || '-' }}
        </p>
        <p v-if="dailyTripData.buyer_2 !== null">
          BUYER 2
        </p>
        <p v-if="dailyTripData.buyer_2 !== null">
          :  {{ dailyTripData.buyer_2 || '-' }}
        </p>
      </div>
      <div class="mt-5">
        <iframe
          :src="ssrsUrl"
          class="w-full h-screen"
          frameborder="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import { PAGE_TITLE } from '@/fixtures/Constants'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  data() {
    return {
      dailyTripData: {},
      isLoading: false
    }
  },
  async mounted() {
    this.fetchDetails()
  },
  computed: {
    ...mapGetters({
      dailyTrip: 'DailyTripActivities/dailyTrip',
      currentPage: 'Table/currentPage'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    },
    ssrsUrl() {
      const url = `${process.env.VUE_APP_SSRS_URL}/DAILY_TRIP_ACTIVITY_REPORT&blu_id=${this.$route.params.blu_id}`;
      return url;
    }
  },
  watch: {
    dailyTrip: {
      immediate: true,
      handler(val) {
        if (val) {
          this.dailyTripData = val[0]
        }
      }
    }
  },
  methods: {
    moment,
    async fetchDetails() {
      try {
        this.isLoading = true
        const blu_id = this.$route.params.blu_id
        if (!blu_id) {
          this.showFailedNotification(this, 'Invalid BLU ID')
          this.isLoading = false
          return
        }

        const apiFilters = {
          sortDir: (this.filters?.sortDir || 'desc').toUpperCase(),
          sortBy: this.filters?.sortBy || 'actual_trip_start',
          page: this.currentPage || 1,
          limit: this.pageSize || 10,
          blu_id: blu_id
        };

        await this.$store.dispatch('DailyTripActivities/fetchDailyTrip', apiFilters)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to fetch Daily Trip Details, please try again')
      }
    },
    async handleBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>

</style>
